/**
 * InfoList 정보 목록
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */

// css
// import "assets/style/elements/info-list.scss";

// elements
import HashTag from 'components/elements/HashTag'
import Text from 'components/elements/Text'

function Element({ children, type, className, hashtag = [], data = [], onClick = () => {} }) {
  // hashtag = ['감자', '감자', '감자', '감자'];

  return (
    <>
      <ul className="basic-list">
        {data.map((item) => (
          // type 1
          <li key={item.id} onClick={() => onClick(item)}>
            <span className="title f-medium">{item.title}</span>
            {hashtag.length > 0 && <HashTag border="false" data={hashtag} />}
            <div className="flex-between mt8">
              <div className="info-area">
                {typeof item?.category !== 'undefined' && <Text className="f-green">{item.category}</Text>}
                {typeof item?.username !== 'undefined' && <Text>{item.username}</Text>}
                <Text>{item.date}</Text>
              </div>
              {typeof item?.commentCount !== 'undefined' && (
                <span className="comment-count f-12">{item.commentCount}</span>
              )}
              {item?.subCommant || ''}
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}

export default Element
